import React from 'react';

/**
 * Which purchase of this title the page is showing.
 *
 * An order document is bought over and over, and the panels around this one
 * describe a single purchase. Past Orders links straight to a specific purchase
 * (`?purchase=N`), so without this the page would silently show the newest one
 * instead of the row that was clicked.
 *
 * Renders nothing when there is only one purchase — most orders.
 */
const PurchaseSelector = ({ purchases, selectedIndex, onSelect }) => {
    if (!purchases || purchases.length < 2) return null;

    const last = purchases.length - 1;
    const isCurrent = selectedIndex === last;

    return (
        <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
            <button
                type="button"
                className="btn btn-sm btn-outline-primary rounded-3"
                disabled={selectedIndex === 0}
                onClick={() => onSelect(selectedIndex - 1)}
            >
                <span className="fas fa-chevron-left" />
            </button>

            <span className="text-white small">
                Purchase <strong className="text-primary">{selectedIndex + 1}</strong> of {purchases.length}
            </span>

            <button
                type="button"
                className="btn btn-sm btn-outline-primary rounded-3"
                disabled={isCurrent}
                onClick={() => onSelect(selectedIndex + 1)}
            >
                <span className="fas fa-chevron-right" />
            </button>

            {!isCurrent && (
                <span className="text-warning small ms-2">
                    <span className="fas fa-clock-rotate-left me-2" />
                    Viewing an earlier purchase — actions are disabled
                    <button
                        type="button"
                        className="btn btn-link btn-sm text-decoration-none py-0"
                        onClick={() => onSelect(last)}
                    >
                        Go to latest
                    </button>
                </span>
            )}
        </div>
    );
};

export default PurchaseSelector;
